import type { PrivateEventDetail } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';

import ClientDealContact from './ClientDealContact';
import ClientDealDeposit from './ClientDealDeposit';
import DealValue from './DealValue';
import ExternalLink from './ExternalLink';
import Fact from './Fact';
import NotRecordedPill from './NotRecordedPill';
import PeopleRow from './PeopleRow';
import { hubspotDealUrl } from './privateEventDisplay';

export default function ClientDealView({ event }: { event: PrivateEventDetail }) {
  const { isPhone } = useViewport();
  const dealUrl = event.hubspotDealId ? hubspotDealUrl(event.hubspotDealId) : null;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1.3fr 1fr', gap: 14 }}>
      <Fact label="Client">
        <strong>{event.clientName}</strong>
      </Fact>
      <Fact label="Point of contact">
        <div style={{ fontWeight: 700 }}>{event.contactName || '—'}</div>
        <ClientDealContact event={event} />
      </Fact>
      <Fact label="Deal value">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <DealValue cents={event.dealValueCents} />
          {event.hubspotDealId && (
            <span style={{ fontSize: 11.5, color: 'var(--nb-muted)' }}>
              HubSpot deal {event.hubspotDealId}
            </span>
          )}
          {dealUrl && <ExternalLink href={dealUrl}>Open in HubSpot</ExternalLink>}
          {event.migrated && !event.hubspotDealId && <NotRecordedPill field="HubSpot deal" short />}
          <ClientDealDeposit event={event} />
        </div>
      </Fact>
      <PeopleRow event={event} />
    </div>
  );
}
